import { TenantPage } from 'components/common';
import { EnhancedDataGrid } from 'components/common/enhanced/data-grid';
import { useTranslation } from 'react-i18next';
import { Button, ButtonGroup } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { IsTenantAdministrator } from 'components/helpers/IsTenantAdministrator';
import AddIcon from '@mui/icons-material/Add';
import { TransportActiveDocumentColumns } from 'components/common/enhanced/common-headers/transport-active-document';
import toast from 'features/toast';
import { supplierTransportActiveDocumentService } from 'services/api/SupplierTransportActiveDocumentService';
import { useState, useEffect, useRef } from 'react';
import { IStatusOption } from 'interfaces';

export function SupplierActiveTransportDocumentList() {
  const { t } = useTranslation();
  const prefix = 'pages.supplier-active-ddt.list';

  const navigate = useNavigate();
  const datagridRefresh = useRef(null);
  const [statusOptions, setStatusOptions] = useState<IStatusOption[]>([]);

  const downloadAttachment = (transportActiveDocumentId) => {
    if (transportActiveDocumentId) {
      supplierTransportActiveDocumentService.downloadAttachment(transportActiveDocumentId);
    }
  };

  const regenerateDocument = (transportActiveDocumentId) => {
    if (transportActiveDocumentId) {
      supplierTransportActiveDocumentService.regeneratePDF(transportActiveDocumentId).then(() => {
        toast.success('PDF rigenerato.');
      });
    }
  };

  useEffect(() => {
    supplierTransportActiveDocumentService.options().then((res) => {
      if (res.actions && res.actions.POST && res.actions.POST.status.choices) {
        const choices = res.actions.POST.status.choices
          .filter((choice) => choice.value !== 0)
          .map((choice) => ({
            ...choice,
            display_name: t(`entities.supplier-active-ddt.${choice.display_name}`)
          }));
        setStatusOptions(choices);
        console.log({ choices }); // For debugging purposes
      }
    });
  }, []);

  const columns = TransportActiveDocumentColumns(
    true,
    downloadAttachment,
    regenerateDocument,
    true // isSupplier
  );

  return (
    <TenantPage
      title={t(`${prefix}.title`)}
      subtitle={t(`${prefix}.subtitle`)}
      menuRight={
        <ButtonGroup size="small">
          <IsTenantAdministrator>
            <Button size="small" onClick={() => navigate('new')}>
              <AddIcon />
              {t(`${prefix}.add`)}
            </Button>
          </IsTenantAdministrator>
        </ButtonGroup>
      }>
      <EnhancedDataGrid
        columns={columns}
        service={supplierTransportActiveDocumentService}
        refresh={datagridRefresh}
      />
    </TenantPage>
  );
}

export default SupplierActiveTransportDocumentList;
